import { useState } from "react";

export default function Faq({ content }) {
  const defaultFaqs = [
    {
      question: "What are the products from Futura Bio Labs intended for?",
      answer:
        "All products sold by Futura Bio Labs are strictly intended for in-vitro research and laboratory use only. They are not intended for human or animal consumption, and are not to be used as food, drugs, cosmetics, or any form of supplementation. By purchasing from Futura Bio Labs, you acknowledge and agree to use our products solely for legitimate research purposes.",
    },
    {
      question: "Are your products regulated or approved by the FDA?",
      answer:
        "No, our products are not approved by the FDA and are sold strictly for research purposes only.",
    },
    {
      question: "Can your products be used for self-experimentation or personal supplementation?",
      answer:
        "No, our products are not intended for human use, self-experimentation, or personal supplementation of any kind.",
    },
    {
      question: "Do I need specific credentials to purchase from Futura Bio Labs?",
      answer:
        "We recommend that only qualified researchers or laboratory professionals purchase and handle our products.",
    },
  ];
  const faqs = content?.faqItems?.length === 4 ? content.faqItems : defaultFaqs;

  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="w-full bg-gray-900 py-[51px] px-[25px] md:px-[51px]">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-gray-300 text-center font-semibold text-[25px] md:text-[38px] mb-[26px]">
          {content?.faqTitle || "Frequently Asked Questions"}
        </h2>

        <div className="flex flex-col gap-4">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className="border border-gray-600 rounded-md"
              >
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center gap-3 text-left text-gray-200 text-[17px] p-[7px]"
                >
                  <span className="flex-shrink-0 text-teal-400">
                    {isOpen ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    )}
                  </span>
                  <span>{faq.question}</span>
                </button>

                <div
                  className="overflow-hidden transition-[max-height] duration-[250ms] ease-in-out"
                  style={{ maxHeight: isOpen ? "500px" : "0px" }}
                >
                  <p className="text-gray-400 text-[17px] p-[7px] pt-0">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}